import { render, staticRenderFns } from "./UCurricularCarreras.vue?vue&type=template&id=7c0acb44&scoped=true&"
import script from "./UCurricularCarreras.vue?vue&type=script&lang=js&"
export * from "./UCurricularCarreras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0acb44",
  null
  
)

export default component.exports